import { useEffect } from 'react';
import { syncDeviceAppVersion } from '@/services/auth/device.service';
import logger from '@/utils/logger';
import { User } from '@/types/auth';

const DEVICE_REGISTRATION_PENDING_KEY = 'deviceRegistrationPending';

export function useDeviceAppVersionSync(user: User | null): void {
  useEffect(() => {
    if (!user) {
      return;
    }

    if (typeof window === 'undefined') {
      return;
    }

    const runSync = () => {
      if (window.localStorage?.getItem(DEVICE_REGISTRATION_PENDING_KEY)) {
        return;
      }

      void syncDeviceAppVersion().catch(error =>
        logger.logError('useDeviceAppVersionSync', 'syncDeviceAppVersion failed', {
          additionalInfo: error
        })
      );
    };

    const timeoutId = window.setTimeout(runSync, 1000);

    const handleSessionRestored = () => {
      runSync();
    };

    window.addEventListener('userSessionRestored', handleSessionRestored as EventListener);

    return () => {
      window.clearTimeout(timeoutId);
      window.removeEventListener('userSessionRestored', handleSessionRestored as EventListener);
    };
  }, [user]);
}
